import { createStore } from 'zustand/vanilla';
import type { StoreApi } from 'zustand/vanilla';

export interface Toast {
  id: number;
  /** Already translated message. */
  message: string;
  kind: 'info' | 'success' | 'error';
  action?: { label: string; run: () => void };
  /** Auto-dismiss after ms; 0 = sticky. */
  timeout: number;
}

export type ToastInput = Omit<Toast, 'id' | 'kind' | 'timeout'> &
  Partial<Pick<Toast, 'kind' | 'timeout'>>;

export interface ToastState {
  toasts: readonly Toast[];
  push(t: ToastInput): number;
  dismiss(id: number): void;
  /** Runs the action of a toast and dismisses it. */
  act(id: number): void;
}

export const MAX_TOASTS = 4;

export function createToastStore(): StoreApi<ToastState> {
  let seq = 1;
  return createStore<ToastState>()((set, get) => ({
    toasts: [],
    push: (t) => {
      const id = seq++;
      const toast: Toast = { kind: 'info', timeout: t.action ? 8000 : 4000, ...t, id };
      set((s) => ({ toasts: [...s.toasts, toast].slice(-MAX_TOASTS) }));
      return id;
    },
    dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
    act: (id) => {
      const t = get().toasts.find((x) => x.id === id);
      if (!t) return;
      get().dismiss(id);
      t.action?.run();
    },
  }));
}

export const toastStore = createToastStore();
